import React from "react";

// Lightweight section heading used across marketing pages
export const SectionHeading = ({ overline, title, subtitle, light = false, align = "left" }) => (
  <div className={`max-w-2xl ${align === "center" ? "mx-auto text-center" : ""}`}>
    {overline && (
      <p className={`overline mb-4 ${light ? "text-gold" : "text-gold"}`}>{overline}</p>
    )}
    <h2
      className={`font-serif font-light text-3xl sm:text-4xl md:text-5xl tracking-tight leading-[1.05] ${
        light ? "text-[#FDFBF7]" : "text-petrol"
      }`}
    >
      {title}
    </h2>
    {subtitle && (
      <p className={`mt-5 text-base leading-relaxed ${light ? "text-white/70" : "text-muted-foreground"}`}>
        {subtitle}
      </p>
    )}
  </div>
);

export default SectionHeading;
